

import React, { useState } from "react";
import * as XLSX from "xlsx";

const Months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];

const getMonthName = (m) => Months[m - 1];

const Onrc_Alloted_Sub_Dist_fps = ({
    month,
    year,
    comm_id,
    dist_code,
    afso_code,
    scheme,
    reportType
}) => {

    const [loading, setLoading] = useState(false);

    const exportExcel = async () => {

        const payload = {
            month: Number(month),
            year: Number(year),
            comm_id: (!comm_id || comm_id === "0") ? null : Number(comm_id),
            scheme_id: (!scheme || scheme === "0") ? null : Number(scheme),
            dist_code: (!dist_code || dist_code === "all") ? null : dist_code,
            afso_code: (!afso_code || afso_code === "all") ? null : afso_code,
            report_type: reportType || "IMPDS"
        };

        setLoading(true);

        try {
            const res = await fetch(
                `${process.env.REACT_APP_URL}/api/onrcReports/afso-fps-wise`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload)
                }
            );

            const json = await res.json();

            if (
                String(json?.rep_code) !== "200" ||
                !Array.isArray(json.data) ||
                json.data.length === 0
            ) {
                alert("No data found");
                setLoading(false);
                return;
            }

            const data = json.data;

            const schemeCommodityMap = {};

            data.forEach(r => {
                const commodity = r.comm_name_en;

                Object.keys(r.schemelist || {}).forEach(k => {
                    const [scheme] = k.split("_");

                    if (!schemeCommodityMap[scheme]) {
                        schemeCommodityMap[scheme] = new Set();
                    }

                    schemeCommodityMap[scheme].add(commodity);
                });
            });

            const grouped = {};

            data.forEach(r => {
                const key = r.sale_fps_id;

                if (!grouped[key]) {
                    grouped[key] = {
                        fps_name: r.fps_name,
                        sale_fps_id: r.sale_fps_id,
                        dist_name: r.dist_name_en || r.dist_name || "",
                        afso_name: r.afso_name_en || r.afso_name || "",
                        date: r.date,
                        values: {}
                    };
                }

                const commodity = r.comm_name_en;

                if (!grouped[key].values[commodity]) {
                    grouped[key].values[commodity] = {};
                }

                Object.keys(r.schemelist || {}).forEach(k => {
                    const [scheme, type] = k.split("_");

                    if (!grouped[key].values[commodity][scheme]) {
                        grouped[key].values[commodity][scheme] = { cards: 0, qty: 0 };
                    }

                    if (type === "cards") {
                        grouped[key].values[commodity][scheme].cards += Number(r.schemelist[k] || 0);
                    }

                    if (type === "qty") {
                        grouped[key].values[commodity][scheme].qty += Number(r.schemelist[k] || 0);
                    }
                });
            });

            const headerRow1 = ["Sl.No", "District", "AFSO", "FPS Id", "FPS Name"];
            const headerRow2 = ["", "", "", "", ""];
            const headerRow3 = ["", "", "", "", ""];

            let colCountCards = 0;

            Object.entries(schemeCommodityMap).forEach(([scheme, commodities]) => {
                const list = Array.from(commodities);
                colCountCards += list.length + 1;

                headerRow2.push(...Array(list.length + 1).fill(scheme));
                headerRow3.push(...list, "Total");
            });

            headerRow1.push(...Array(colCountCards).fill("CARDS"));

            let colCountQty = 0;

            Object.entries(schemeCommodityMap).forEach(([scheme, commodities]) => {
                const list = Array.from(commodities);
                colCountQty += list.length + 1;

                headerRow2.push(...Array(list.length + 1).fill(scheme));
                headerRow3.push(...list, "Total");
            });

            headerRow1.push(...Array(colCountQty).fill("QTY"));

            const districtName = (!dist_code || dist_code === "all")
                ? "All Districts"
                : (data[0]?.dist_name_en || dist_code);

            const commodityName = (!comm_id || comm_id === "0")
                ? "All Commodities"
                : (data[0]?.comm_name_en || "");

            const monthName = getMonthName(month);
            const reportTypeName = reportType || "IMPDS";

            const totalCols =
                5 +
                Object.values(schemeCommodityMap).reduce(
                    (acc, s) => acc + s.size + 1,
                    0
                ) * 2;

            const titleRow = [
                `FPS Wise - ${districtName}-${commodityName}-${monthName} ${year}-${reportTypeName}`
            ];
            while (titleRow.length < totalCols) titleRow.push("");


            const reportDate = data[0]?.date || "";
            const dateRow = new Array(totalCols - 1).fill("");
            dateRow.push(`Date: ${reportDate}`);

            const rows = [titleRow, dateRow, headerRow1, headerRow2, headerRow3];


            Object.values(grouped).forEach((r, i) => {

                const row = [
                    i + 1,
                    r.dist_name,
                    r.afso_name,
                    r.sale_fps_id,
                    r.fps_name
                ];

                Object.entries(schemeCommodityMap).forEach(([scheme, commodities]) => {
                    let total = 0;

                    Array.from(commodities).forEach(comm => {
                        const val = r.values?.[comm]?.[scheme]?.cards || 0;
                        total += val;
                        row.push(val);
                    });

                    row.push(total);
                });

                Object.entries(schemeCommodityMap).forEach(([scheme, commodities]) => {
                    let total = 0;

                    Array.from(commodities).forEach(comm => {
                        const val = r.values?.[comm]?.[scheme]?.qty || 0;
                        total += val;
                        row.push(val);
                    });

                    row.push(total);
                });

                rows.push(row);
            });


            const ws = XLSX.utils.aoa_to_sheet(rows);
            ws["!merges"] = [];


            ws["!merges"].push({
                s: { r: 0, c: 0 },
                e: { r: 0, c: totalCols - 1 }
            });


            for (let c = 0; c < 5; c++) {
                ws["!merges"].push({
                    s: { r: 2, c },
                    e: { r: 4, c }
                });
            }

            let colIndex = 5;

            const cardsStart = colIndex;

            Object.values(schemeCommodityMap).forEach(commodities => {
                const size = commodities.size + 1;

                ws["!merges"].push({
                    s: { r: 3, c: colIndex },
                    e: { r: 3, c: colIndex + size - 1 }
                });

                colIndex += size;
            });

            ws["!merges"].push({
                s: { r: 2, c: cardsStart },
                e: { r: 2, c: colIndex - 1 }
            });

            const qtyStart = colIndex;

            Object.values(schemeCommodityMap).forEach(commodities => {
                const size = commodities.size + 1;

                ws["!merges"].push({
                    s: { r: 3, c: colIndex },
                    e: { r: 3, c: colIndex + size - 1 }
                });

                colIndex += size;
            });

            ws["!merges"].push({
                s: { r: 2, c: qtyStart },
                e: { r: 2, c: colIndex - 1 }
            });

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "FPS Report");

            XLSX.writeFile(wb, `FPS_Report_${monthName}_${year}.xlsx`);

        } catch (err) {
            console.error(err);
            alert("Error downloading Excel");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div align="center">
            <button
                className="button button2"
                onClick={exportExcel}
                disabled={loading}
            >
                {"Download Excel"}
            </button>
        </div>
    );
};

export default Onrc_Alloted_Sub_Dist_fps;

